import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { MwVehicleGroupsApiService } from 'app/services/vehicle-groups-api.service';
import * as vehicleGroupsActions from '../actions/vehicle-groups.actions';
import * as notifyActions from 'app/store/general/actions/notify.actions';

@Injectable()
export class VehicleGroupsEffects {
  loadVehicleGroups$ = createEffect(() =>
    this.actions$.pipe(
      ofType(vehicleGroupsActions.loadVehicleGroups),
      switchMap(({ loadOptions }) =>
        this.vehicleGroupsApiService.getVehicleGroups(loadOptions).pipe(
          map((response) =>
            vehicleGroupsActions.loadVehicleGroupsSuccess({ response })
          ),
          catchError((error) =>
            of(vehicleGroupsActions.loadVehicleGroupsFailed({ error }))
          )
        )
      )
    )
  );

  createVehicleGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(vehicleGroupsActions.createVehicleGroup),
      switchMap(({ vehicleGroup }) =>
        this.vehicleGroupsApiService.createVehicleGroup(vehicleGroup).pipe(
          switchMap(() => [
            vehicleGroupsActions.createVehicleGroupSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.add_vehicle_group_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(vehicleGroupsActions.createVehicleGroupFailed({ error }))
          )
        )
      )
    )
  );

  updateVehicleGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(vehicleGroupsActions.updateVehicleGroup),
      switchMap(({ vehicleGroup }) =>
        this.vehicleGroupsApiService.updateVehicleGroup(vehicleGroup).pipe(
          switchMap((response) => [
            vehicleGroupsActions.updateVehicleGroupSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.edit_vehicle_group_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(vehicleGroupsActions.updateVehicleGroupFailed({ error }))
          )
        )
      )
    )
  );

  deleteVehicleGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(vehicleGroupsActions.deleteVehicleGroup),
      switchMap(({ vehicleGroup }) =>
        this.vehicleGroupsApiService.deleteVehicleGroup(vehicleGroup).pipe(
          switchMap(() => [
            vehicleGroupsActions.deleteVehicleGroupSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.delete_vehicle_group_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(vehicleGroupsActions.deleteVehicleGroupFailed({ error }))
          )
        )
      )
    )
  );

  deleteVehicleGroupsList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(vehicleGroupsActions.deleteVehicleGroupsList),
      switchMap(({ vehicleGroups }) =>
        this.vehicleGroupsApiService
          .deleteVehicleGroupsList(vehicleGroups)
          .pipe(
            switchMap(() => [
              vehicleGroupsActions.deleteVehicleGroupsListSuccess(),
              notifyActions.notifySuccess({
                notification: {
                  phrase: 'OPERATION.delete_vehicle_groups_successful',
                },
              }),
            ]),
            catchError((error) =>
              of(vehicleGroupsActions.deleteVehicleGroupsListFailed({ error }))
            )
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private vehicleGroupsApiService: MwVehicleGroupsApiService
  ) {}
}
